import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  I18n,
  Link,
} from 'components';

import AccountPreview from '../AccountPreview';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class AccountGroupPreview extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hidden: true,
    };
  }

  render() {
    const {
      ben,
      ban,
      login,
      isPostpaid,
      subscribers,
      emailRegular,
      invoiceAddress,
      invoiceEmail,
      openAccountEditPopup,
      openAccountGroupEditPopup,
    } = this.props;

    const { hidden } = this.state;

    return (
      <div className={cx('component')}>
        <div className={cx('benWrapper')}>
          <div
            role="presentation"
            className={cx('benTitleWrapper')}
          >
            <Link
              className={cx('benTitle')}
              onClick={() => this.setState({
                hidden: !hidden,
              })}
            >
              <I18n
                path="settings.numberManagement.associatedAccounts.groupTitle"
                vars={{ ben }}
              />
            </Link>
            <i className={cx('arrow', {
              up: !hidden,
              down: hidden,
            })}
            />
          </div>
          {isPostpaid
            && (
            <Link
              className={cx('editLink')}
              onClick={() => openAccountGroupEditPopup({
                ben,
                ban,
                login,
                emailRegular,
                invoiceAddress,
                invoiceEmail,
              })}
            >
              <I18n path="common.edit" />
            </Link>
            )}
        </div>
        <DataBlocks.Table
          className={cx('table', { hidden })}
        >
          {subscribers.map((account) => (
            <AccountPreview
              isMobile
              key={`ctn-account-${account.login}`}
              banLogin={login}
              {...account}
              openAccountEditPopup={openAccountEditPopup}
            />
          ))}
        </DataBlocks.Table>
      </div>
    );
  }
}

AccountGroupPreview.propTypes = {
  ben: PropTypes.number,
  ban: PropTypes.number,
  login: PropTypes.string,
  isPostpaid: PropTypes.bool,
  subscribers: PropTypes.array,
  emailRegular: PropTypes.bool,
  invoiceAddress: PropTypes.string,
  invoiceEmail: PropTypes.string,
  openAccountEditPopup: PropTypes.func,
  openAccountGroupEditPopup: PropTypes.func,
};

export default AccountGroupPreview;
